import { Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { resolvePostAuthRoute } from '@/lib/authRedirect';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: 'admin' | 'user';
}

export function ProtectedRoute({ children, requiredRole }: ProtectedRouteProps) {
  const { user, profile, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <div className="text-center">
          <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent mx-auto mb-4"></div>
          <p className="text-muted-foreground">Cargando...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  // Check if email is confirmed
  if (!user.email_confirmed_at) {
    return <Navigate to="/auth/verify-required" replace />;
  }

  if (requiredRole) {
    // Check if user has required role (admin includes super_admin access)
    const userRole = profile?.role;
    const hasAccess = 
      userRole === requiredRole ||
      (requiredRole === 'admin' && userRole === 'super_admin');

    if (!hasAccess) {
      return <Navigate to={resolvePostAuthRoute({
        plan: profile?.plan,
        opositorBody: profile?.opositor_body,
      })} replace />;
    }
  }

  return <>{children}</>;
}
